export default "__VITE_ASSET__LsOuDx3F__"